import {
  put, takeEvery, select,
} from 'redux-saga/effects';
import {
  ACT_INSTANCES_FETCH_ELEMENTS_INIT_ACTION,
  ACT_INSTANCES_GET_ELEMENT_INIT_ACTION,
  ACT_INSTANCES_ADD_ELEMENT_INIT_ACTION,
  ACT_INSTANCES_DELETE_ELEMENT_INIT_ACTION,
  ACT_INSTANCES_UPDATE_ELEMENTS_FILTERS,
} from '../../constants/actions';
import {
  addElementSuccessAction,
  deleteElementSuccessAction,
  fetchElementsSuccessAction,
  getElementSuccessAction,
} from '../../actions/instances/elements';
import Api from '../../services/Api';

function* fetchElements() {
  const { filters } = yield select(state => state.buildingElementInstance);
  let query = '';
  if (filters.dynasties.length > 0) {
    query += filters.dynasties.map(dynasty => `&dynasties_ids[]=${dynasty}`);
  }
  if (filters.cities.length > 0) {
    query += filters.cities.map(city => `&cities_ids[]=${city}`);
  }
  if (filters.tags.length > 0) {
    query += filters.tags.map(tag => `&tags_ids[]=${tag}`);
  }
  const { status, data } = yield Api.get(`instances/building-elements?per_page=50${query}`, false);
  if (status === 200) {
    yield put(fetchElementsSuccessAction(data.data));
  }
}

function* getElement(action) {
  const { status, data } = yield Api.get(`instances/building-elements/${action.payload}`, false);
  if (status === 200) {
    yield put(getElementSuccessAction(data));
  }
}

function* addElement(action) {
  const { status, data } = yield Api.post('instances/building-elements', action.payload, false);
  if (status === 200) {
    yield put(addElementSuccessAction(data));
  }
}

function* deleteElement(action) {
  const { status } = yield Api.delete(`instances/building-components/${action.payload}`, false);
  if (status === 204) {
    yield put(deleteElementSuccessAction());
  }
}

export default function* elementsSagas() {
  yield takeEvery([
    ACT_INSTANCES_FETCH_ELEMENTS_INIT_ACTION,
    ACT_INSTANCES_UPDATE_ELEMENTS_FILTERS,
  ], fetchElements);
  yield takeEvery(ACT_INSTANCES_GET_ELEMENT_INIT_ACTION, getElement);
  yield takeEvery(ACT_INSTANCES_ADD_ELEMENT_INIT_ACTION, addElement);
  yield takeEvery(ACT_INSTANCES_DELETE_ELEMENT_INIT_ACTION, deleteElement);
}
